var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Cordova, IonicNativePlugin, Plugin } from '@ionic-native/core';
/**
 * @name Location Accuracy
 * @description
 * This Cordova/Phonegap plugin for Android and iOS to request enabling/changing of Location Services by triggering a native dialog from within the app, avoiding the need for the user to leave your app to change location settings manually.
 *
 * @usage
 * ```typescript
 * import { LocationAccuracy } from '@ionic-native/location-accuracy';
 *
 * constructor(private locationAccuracy: LocationAccuracy) { }
 *
 * ...
 *
 * this.locationAccuracy.canRequest().then((canRequest: boolean) => {
 *
 *   if(canRequest) {
 *     // the accuracy option will be ignored by iOS
 *     this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
 *       () => console.log('Request successful'),
 *       error => console.log('Error requesting location permissions', error)
 *     );
 *   }
 *
 * });
 *
 * ```
 */
var LocationAccuracy = (function (_super) {
    __extends(LocationAccuracy, _super);
    function LocationAccuracy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.REQUEST_PRIORITY_NO_POWER = 0;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.REQUEST_PRIORITY_LOW_POWER = 1;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.REQUEST_PRIORITY_BALANCED_POWER_ACCURACY = 2;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.REQUEST_PRIORITY_HIGH_ACCURACY = 3;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.SUCCESS_SETTINGS_SATISFIED = 0;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.SUCCESS_USER_AGREED = 1;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.ERROR_ALREADY_REQUESTING = -1;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.ERROR_INVALID_ACTION = 0;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.ERROR_INVALID_ACCURACY = 1;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.ERROR_EXCEPTION = 1;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.ERROR_CANNOT_CHANGE_ACCURACY = 3;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.ERROR_USER_DISAGREED = 4;
        /**
           * Convenience constant
           * @type {number}
           */
        _this.ERROR_GOOGLE_API_CONNECTION_FAILED = 4;
        return _this;
    }
    /**
     * Indicates if you can request accurate location
     * @returns {Promise<boolean>} Returns a promise that resovles with a boolean that indicates if you can request accurate location
     */
    /**
       * Indicates if you can request accurate location
       * @returns {Promise<boolean>} Returns a promise that resovles with a boolean that indicates if you can request accurate location
       */
    LocationAccuracy.prototype.canRequest = /**
       * Indicates if you can request accurate location
       * @returns {Promise<boolean>} Returns a promise that resovles with a boolean that indicates if you can request accurate location
       */
    function () { return; };
    /**
     * Indicates if a request is currently in progress
     * @returns {Promise<boolean>} Returns a promise that resolves with a boolean that indicates if a request is currently in progress
     */
    /**
       * Indicates if a request is currently in progress
       * @returns {Promise<boolean>} Returns a promise that resolves with a boolean that indicates if a request is currently in progress
       */
    LocationAccuracy.prototype.isRequesting = /**
       * Indicates if a request is currently in progress
       * @returns {Promise<boolean>} Returns a promise that resolves with a boolean that indicates if a request is currently in progress
       */
    function () { return; };
    /**
     * Requests accurate location
     * @param accuracy {number} Accuracy, from 0 to 4. You can use the static properties of this class that start with REQUEST_PRIORITY_
     * @returns {Promise<any>} Returns a promise that resolves on success and rejects if an error occurred
     */
    /**
       * Requests accurate location
       * @param accuracy {number} Accuracy, from 0 to 4. You can use the static properties of this class that start with REQUEST_PRIORITY_
       * @returns {Promise<any>} Returns a promise that resolves on success and rejects if an error occurred
       */
    LocationAccuracy.prototype.request = /**
       * Requests accurate location
       * @param accuracy {number} Accuracy, from 0 to 4. You can use the static properties of this class that start with REQUEST_PRIORITY_
       * @returns {Promise<any>} Returns a promise that resolves on success and rejects if an error occurred
       */
    function (accuracy) { return; };
    LocationAccuracy.decorators = [
        { type: Injectable },
    ];
    __decorate([
        Cordova(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LocationAccuracy.prototype, "canRequest", null);
    __decorate([
        Cordova(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LocationAccuracy.prototype, "isRequesting", null);
    __decorate([
        Cordova({ callbackOrder: 'reverse' }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], LocationAccuracy.prototype, "request", null);
    /**
     * @name Location Accuracy
     * @description
     * This Cordova/Phonegap plugin for Android and iOS to request enabling/changing of Location Services by triggering a native dialog from within the app, avoiding the need for the user to leave your app to change location settings manually.
     *
     * @usage
     * ```typescript
     * import { LocationAccuracy } from '@ionic-native/location-accuracy';
     *
     * constructor(private locationAccuracy: LocationAccuracy) { }
     *
     * ...
     *
     * this.locationAccuracy.canRequest().then((canRequest: boolean) => {
     *
     *   if(canRequest) {
     *     // the accuracy option will be ignored by iOS
     *     this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
     *       () => console.log('Request successful'),
     *       error => console.log('Error requesting location permissions', error)
     *     );
     *   }
     *
     * });
     *
     * ```
     */
    LocationAccuracy = __decorate([
        Plugin({
            pluginName: 'LocationAccuracy',
            plugin: 'cordova-plugin-request-location-accuracy',
            pluginRef: 'cordova.plugins.locationAccuracy',
            repo: 'https://github.com/dpa99c/cordova-plugin-request-location-accuracy',
            platforms: ['Android', 'iOS']
        })
    ], LocationAccuracy);
    return LocationAccuracy;
}(IonicNativePlugin));
export { LocationAccuracy };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ionic-native/location-accuracy/index.js
// module id = 521
// module chunks = 57